/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getBookmark = /* GraphQL */ `
  query GetBookmark($id: ID!) {
    getBookmark(id: $id) {
      id
      description
      viewState {
        center
        zoom
        __typename
      }
      layers {
        layerId
        layerTitle
        assetType
        assetUrl
        subLayers {
          gene
          assetUrl
          visibility
        }
        rasterOpacity
        circleColor
        circleRadius
        circleOpacity {
          opacityOnHover
          opacity
        }
        sgeCheckbox {
          type
          checked
        }
        fillOpacity
        colormap
        visibility
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listBookmarks = /* GraphQL */ `
  query ListBookmarks(
    $filter: ModelBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookmarks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        description
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
